import { connect } from 'react-redux';
import App from './app';
import { navigate } from '../app/reducers/navigator.reducers';
import { loginSucceeded, onLoadConfiguration } from '../app/reducers/auth.reducers';

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
});

const mapDispatchToProps = dispatch => ({
  navigateToHome: () => dispatch(navigate({ route: '/' })),
  navigateTo: routeName => dispatch(navigate({ route: routeName })),
  setAccessToken: accessToken => dispatch(loginSucceeded({ accessToken, expiresIn: 1000000000 })),
  loadConfig: () => dispatch(onLoadConfiguration())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/app/app.container.js